import type { CSSProperties } from 'react';
import type { HeroConfig } from '../types/hero';

function hexToRgb(hex: string) {
  const clean = hex.replace('#', '').trim();

  if (clean.length === 3) {
    return {
      r: parseInt(clean[0] + clean[0], 16),
      g: parseInt(clean[1] + clean[1], 16),
      b: parseInt(clean[2] + clean[2], 16),
    };
  }

  if (clean.length === 6) {
    return {
      r: parseInt(clean.slice(0, 2), 16),
      g: parseInt(clean.slice(2, 4), 16),
      b: parseInt(clean.slice(4, 6), 16),
    };
  }

  return null;
}

function hexToRgba(hex: string, opacity: number) {
  const rgb = hexToRgb(hex);
  if (!rgb) return `rgba(15, 23, 42, ${opacity})`;
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
}

export function getHeroBackgroundStyle(hero: HeroConfig): CSSProperties {
  if (hero.hero_background_mode === 'solid') {
    return {
      background: hero.hero_solid_color || '#0f172a',
    };
  }

  if (hero.hero_background_mode === 'overlay') {
    return {
      background: hexToRgba(
        hero.hero_overlay_color || '#0f172a',
        hero.hero_overlay_opacity ?? 0.62
      ),
    };
  }

  if (hero.hero_background_mode === 'gradient') {
    return {
      background: `linear-gradient(${
        hero.hero_gradient_direction || '135deg'
      }, ${
        hexToRgba(
          hero.hero_gradient_from || '#0f3d3e',
          hero.hero_gradient_opacity ?? 1
        )
      }, ${
        hexToRgba(
          hero.hero_gradient_to || '#f57c00',
          hero.hero_gradient_opacity ?? 1
        )
      })`,
    };
  }

  return {
    background:
      hero.hero_background_gradient ||
      'linear-gradient(135deg, rgba(15, 61, 62, 0.88) 0%, rgba(15, 23, 42, 0.55) 55%, rgba(245, 124, 0, 0.28) 100%)',
  };
}